import React from 'react';
import Header from './components/Header';
import AboutMe from './components/AboutMe';
import Directions from './components/Directions';
import Science from './components/Science';
import School from './components/School';
import Solutions from './components/Solutions';
import Talks from './components/Talks';
import Contacts from './components/Contacts';
import Footer from './components/Footer';
import './App.css';

function App() {
  return (
    <div className="App">
      <Header />
      <main>
        <AboutMe />
        <Directions />
        <Science />
        <School />
        <Solutions />
        <Talks />
        <Contacts />
      </main>
      <Footer />
    </div>
  );
}

export default App;
